import { render, staticRenderFns } from "./YaJinBuJiaoRecord.vue?vue&type=template&id=635fd4e4&scoped=true&"
import script from "./YaJinBuJiaoRecord.vue?vue&type=script&lang=js&"
export * from "./YaJinBuJiaoRecord.vue?vue&type=script&lang=js&"
import style0 from "./YaJinBuJiaoRecord.vue?vue&type=style&index=0&id=635fd4e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635fd4e4",
  null
  
)

export default component.exports